import { CurrencyPipe } from "@angular/common";
import { Component, inject, input, ViewEncapsulation } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { MaterialModule } from "src/app/material.module";
import { ProviderClaimTypesGetDTO } from "src/app/pages/providers/provider.model";
import { OtherClaimChartComponent } from "../../charts/other-claim-chart/other-claim-chart.component";
import { OtherClaimsWidgetKpi } from "../../models/dashboard-widget-kpi.model";
import { DashboardListNavigationContext } from "../../models/dashboard-list-navigation.model";
import { DashboardNavigationService } from "../../services/dashboard-navigation.service";

@Component({
  selector: "app-dashboard-other-claims-widget",
  standalone: true,
  imports: [
    MaterialModule,
    TranslateModule,
    CurrencyPipe,
    OtherClaimChartComponent,
  ],
  templateUrl: "./other-claims-widget.component.html",
  encapsulation: ViewEncapsulation.None,
})
export class OtherClaimsWidgetComponent {
  private readonly navigationSvc = inject(DashboardNavigationService);

  readonly kpi = input.required<OtherClaimsWidgetKpi>();
  readonly claimTypes = input.required<ProviderClaimTypesGetDTO[]>();
  readonly listNavigation = input.required<DashboardListNavigationContext>();

  onClaimTypeSelected(claimType: string): void {
    this.navigationSvc.navigateToClaimTypeView(this.listNavigation(), claimType);
  }
}
